import Vue from 'vue';
import App from './App.vue';
import axios from 'axios';

// const api = axios.create({
//     baseURL: 'https://marketingapi.test'
// })

const api = axios.create({
    baseURL: 'https://integration.myoutdesk.com/'
});




Vue.config.productionTip = false;
Vue.http = Vue.prototype.$http = api;


new Vue({
    render: h => h(App),
}).$mount('#app');
